export default "__VITE_PUBLIC_ASSET__8ec1d72b__"